<template>
  <main>
    <v-dialog v-model="saveDialog" max-width="600">
      <ConfirmModal
          :title="`${commonQuestions.id ? 'Atualizar Promoção' : 'Cadastrar Promoção'}`"
          :textMessage="`${commonQuestions.id ? 'Atualizar' : 'Cadastrar '}?`"
          :textObservation1="`Tem certeza que deseja ${commonQuestions.id ? 'Atualizar a pergunta:' : 'cadastrar pergunta'}`"
          :textObservation2="`${commonQuestions.question}?`"
          cancelBtn="Cancelar"
          :okbtn="`${commonQuestions.id ? 'Atualizar' : 'Cadastrar'}`"
          textObservation=""
          @close="(saveDialog = false)"
          @action="submit()"
          :key="dialogKey"
      />
    </v-dialog>

    <Header
        buttonTitle=""
        title="Cadastrar Pergunta"
        text="Perguntas Frequentes"
        @voltar="goToRoute('/perguntasFrequentesAdmin')"
        :haveAction="false"
        :haveBack="true"
    />

    <v-card class="mx-3">
      <v-form ref="commonQuestionsForm" v-model="commonQuestionsForm" :key="clear">
        <v-row cols="12" sm="12" md="12" lg="12" class="ma-0">
          <v-col cols="12" sm="12" md="12" lg="12">
            <span class="ml-1 mb-2 label-details">Pergunta</span>
            <v-textarea
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                type="text"
                hide-details
                placeholder="Digite a pergunta"
                v-model="commonQuestions.question"
                :rules="[rules.required]"
            ></v-textarea>
          </v-col>

          <v-col cols="12" sm="12" md="12" lg="12">
            <span class="ml-1 mb-2 label-details">Resposta</span>
            <v-textarea
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                type="text"
                hide-details
                placeholder="Digite a resposta"
                v-model="commonQuestions.answer"
                :rules="[rules.required]"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>

      <v-row class="ma-0 mb-5 mt-3" justify="center">
        <v-col cols="12" sm="6" md="6" lg="6" class="d-flex justify-center">
          <v-btn
              class="cancel-button"
              outlined
              height="50"
              width="100%"
              style="border-radius: 10px"
              @click="back"
          >
            Cancelar
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" class="d-flex justify-center">
          <v-btn
              width="100%"
              class="primary-button d-flex justify-content-center"
              style="font-weight: bold !important; font-size: 16px !important; height: 50px!important;"
              :loading="loading"
              @click="validate()"
          >
            {{ commonQuestions.id ? "Alterar Pergunta" : "Cadastrar Pergunta" }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

  </main>
</template>

<script lang="js">
import ApiService from '../../../../services/ApiService';
import Header from "./Header";
/*import DeleteModal from "../../components/DeleteModal";*/
import ConfirmModal from "../../components/ConfirmModal";
import _ from 'underscore'
import moment from 'moment'
import Vue from "vue";

export default {
  name: "CommonQuestionsRegister",
  components: {
    Header,
    ConfirmModal,
    /*DeleteModal*/
  },

  data() {
    return {
      dialogKey: 1,
      deleteDialog: false,
      saveDialog: false,
      env_url: "",
      loading: false,
      isEditing: false,
      commonQuestionsForm: null,
      commonQuestions: {
        id: null,
        question: null,
        answer: null,
      },
      clear: false,
      apiService: new ApiService(),
      rules: {
        nameRules: (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
        required: (value) => !!value || "Campo requerido.",
        min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
        postalCodeRules: (v) => (v && v.length <= 10) || "CEP deve ter no máximo 10 caracteres",
      },
    }
  },
  created() {
    this.env_url = process.env.VUE_APP_BASE_URL;
  },
  async mounted() {
    this.commonQuestions.id = this.$route.query.id
    if (this.commonQuestions.id) {
      await this.getOneCommonQuestions(this.commonQuestions.id)
    }
  },
  computed: {},
  methods: {
    /*showModalRemoveProduct(productId) {
      this.deleteDialog = true
      this.productIdRemove = productId
    },

    removeProduct() {
      this.deleteDialog = false
      const productIndex = this.selectedProducts.findIndex((x) => x.productId === this.productIdRemove)
      this.selectedProducts.splice(productIndex, 1)
    },

    async setProduct() {
      try {
        if (this.product) {
          this.loading = true
          let product = this.selectedProducts.find((x) => x.productId === this.product)
          if (!product) {
            product = await this.getOneProduct(this.product)
            this.selectedProducts.push(product)
          }
          this.loading = false
        }
      } catch (e) {

      }
    },

    async getOneProduct(productId) {
      try {
        return await this.apiService.get(`product/get-one?id=${productId}`);
      } catch (e) {

      }
    },



    setBenefit() {
      this.options.prefix = this.promotion.discountType === 1 ? "%" : "R$"
      this.options.precision = this.promotion.discountType === 1 ? 1 : 2
    },

    */

    async getOneCommonQuestions(id) {
      try {
        this.apiService
            .get(`commonQuestions/${id}`)
            .then((response) => {
              const {content} = response
              this.commonQuestions = content
            });
      } catch (e) {

      }
    },
    async back() {
      await this.goToRoute('/perguntasFrequentesAdmin')
    },

    validate() {
      if (!this.$refs.commonQuestionsForm.validate()) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Preencha todos os campos corretamente!",
          trace: null,
        });
        return
      }
      this.saveDialog = true
    },

    async submit() {
      try {
        this.saveDialog = false
        let method = `post`
        let url = `commonQuestions`

        if (this.commonQuestions.id) {
          method = `put`
          url = `commonQuestions/${this.commonQuestions.id}`
        }

        this.apiService[method](url, this.commonQuestions)
            .then((response) => {
              const {content} = response
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: content ? content : "Pergunta cadastrada com sucesso!",
                trace: null,
              });
              this.back()
            })
            .catch((error) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: "Não foi possível cadastrar a pergunta!",
                trace: null,
              });
              this.loading = false;
            });
      } catch (e) {

      }
    },

    async goToRoute(route) {
      if (this.$route.path !== route) {
        await this.$router.push(route);
      }
    },

    /*async listAllPrducts(query) {
      try {
        this.loading = true
        this.filter.product = query
        const {products} = await this.apiService.post(`product/listActiveB2C`, this.filter, false, false, false)
        this.loading = false
        return products
      } catch (e) {
        this.loading = false
      }
    },*/


  },

  watch: {}
};
</script>

<style scoped>
.list-product-content {
  /*display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(250px, auto));*/
}


</style>
